import { track } from '@vercel/analytics';

// Enable debug mode in development
const DEBUG = process.env.NODE_ENV === 'development';

/**
 * Custom event tracking for Vercel Analytics
 * 
 * @param eventName - Name of the event to track
 * @param properties - Optional properties to include with the event
 */
export const trackEvent = (eventName: string, properties?: Record<string, string | number | boolean>) => {
  track(eventName, properties);
  
  // Log tracking events in development
  if (DEBUG) {
    console.group('📊 Analytics Event');
    console.log('Event:', eventName);
    console.log('Properties:', properties);
    console.groupEnd();
  }
};

/**
 * Track page views manually (use when route changes don't trigger automatic tracking)
 * 
 * @param pageName - Name of the page being viewed
 */
export const trackPageView = (pageName: string) => {
  track('page_view', { page: pageName });
  
  // Log page views in development
  if (DEBUG) {
    console.group('📊 Page View');
    console.log('Page:', pageName);
    console.groupEnd();
  }
};

/**
 * Track user interactions with ads
 * 
 * @param adId - ID of the ad
 * @param action - Action performed (view, click, etc)
 * @param position - Optional position of the ad
 */
export const trackAdInteraction = (adId: string, action: 'view' | 'click' | 'dismiss', position?: string) => {
  const properties = {
    ad_id: adId,
    action,
    position: position || 'unknown',
    timestamp: Date.now()
  };
  
  track('ad_interaction', properties);
  
  // Log ad interactions in development
  if (DEBUG) {
    console.group('📊 Ad Interaction');
    console.log('Ad ID:', adId);
    console.log('Action:', action);
    console.log('Position:', position || 'unknown');
    console.groupEnd();
  }
}; 